<form [formGroup]="form" #f="ngForm">
  <div class="input-row-name" formGroupName="load" [glPremium]="true">
    <gl-input-container>
      <input data-ctx="input-name" type="text" placeholder="name" normal-input formControlName="name" />
    </gl-input-container>

    <div class="palleteButton iconButton" [ngClass]="{'activeButton': currentType === 0}" (click)="changeType(0)">
      <gl-icon name="cubeIco" class="palleteIcon outline-icon-button"></gl-icon>
    </div>
    <div class="palleteButton iconButton" [ngClass]="{'activeButton': currentType === 2}" (click)="changeType(2)">
      <gl-icon name="pipeIco" class="palleteIcon"></gl-icon>
    </div>
    <div class="palleteButton iconButton" [ngClass]="{'activeButton': currentType === 1}" (click)="changeType(1)">
      <gl-icon name="barrelIco" class="palleteIcon"></gl-icon>
    </div>

    <button outline-icon-button class="palleteButton" (click)="openColorPicker()">
      <gl-icon name="color-pallete" class="palleteIcon"></gl-icon>
    </button>
  </div>
  <div class="input-row" formGroupName="load">
    @if (currentType === 0 || currentType === undefined || currentType === 2) {
      <gl-input-container
        [units]="'length'"
        [glPremium]="true"
        >
        <input
          type="text"
          [numericType]="'float'"
          placeholder="length"
          normal-input
          formControlName="length"
          />
      </gl-input-container>
    }
    @if (currentType === 0 || currentType === undefined) {
      <gl-input-container
        [units]="'length'"
        [glPremium]="true"
        >
        <input
          type="text"
          [numericType]="'float'"
          placeholder="width"
          normal-input
          formControlName="width"
          />
      </gl-input-container>
    }
    @if (currentType === 0 || currentType === undefined || currentType === 1) {
      <gl-input-container
        [units]="'length'"
        [glPremium]="true"
        >
        <input
          type="text"
          [numericType]="'float'"
          placeholder="height"
          normal-input
          formControlName="height"
          />
      </gl-input-container>
    }
    @if (currentType === 1 || currentType === 2) {
      <gl-input-container
        [units]="'length'"
        [glPremium]="true"
        >
        <input
          type="text"
          [numericType]="'float'"
          placeholder="diameter"
          normal-input
          formControlName="diameter"
          />
      </gl-input-container>
    }
    @if (currentType === 1 || currentType === 2) {
      <gl-load-arrangement class="arrangementContainer" [stackingOptions]="stackingOptions"
        [currentType] = "currentType"
      (loadArrangementChange)="loadArrangementChange($event)"></gl-load-arrangement>
    }
  </div>
  <div class="input-row" formGroupName="load">
    <gl-input-container [units]="'weight'">
      <input
        type="text"
        [numericType]="'float'"
        placeholder="weight"
        normal-input
        formControlName="weight"
        />
    </gl-input-container>
    <gl-input-container [units]="'weight'">
      <input
        type="text"
        [numericType]="'float'"
        placeholder="sum_of_weights"
        normal-input
        formControlName="sumOfWeights"
        />
    </gl-input-container>
  </div>

  <div class="input-row" formGroupName="load">
    <gl-input-container>
      <input
        type="text"
        [numericType]="'integer'"
        placeholder="quantity"
        normal-input
        formControlName="quantity"
        />
    </gl-input-container>
  </div>
  @if (showPalletLayerActions) {
    <div class="input-row" formGroupName="load" [glPremium]="true">
      <button
        outline-button
        [class.recalculateButton]="isLayerCalculationStale"
        [class.actionBlocked]="isCreateLayerBlocked"
        (click)="createLayer($event)"
        >{{ (isLayerCalculationStale ? 'recalculate_a_layer' : 'create_a_layer') | translate }}</button>

      @if (showFillPalletAction) {
        <button outline-button (click)="fillPallet($event)">{{ 'fill_the_pallet' | translate }}</button>
      }
    </div>
  }

  <div class="buttonRow" data-ctx="container-buttons">
    @if (checkboxActive) {
      <gl-icon-checkbox
        [checkboxFormGroup]="saveLoadForm"
        [tooltipInfo]="'save_info'"
        [controlName]="'remember'"
        [iconName]="'saveIcon'"
        (click)="saveLoadClick($event)"
      ></gl-icon-checkbox>
    }
    @if (!isMyLoads && project.workSpaces.length > 1 && !hasLoadedPalletLayers && !quantityLockedForLayers) {
      <div class="addToFirst">
        <gl-slide-toggle (click)="addToFirstHandler()"></gl-slide-toggle>
        <span class="addToFirstDescription">{{ 'add_to_first' | translate }}</span>
        <div class="info" [glTooltip]="'add_to_first_info'">i</div>
      </div>
    }
    @if (project.workSpaces.length <= 1) {
      <div
        class="submitWrapper"
        [glPremium]="chosenLoad?.isUser"
        [glTooltip]="individualAddBlocked ? 'individual_add_blocked_stacking_mode' : null"
        [disableTooltip]="!individualAddBlocked"
        >
        @if (!isMyLoads) {
          <button
            outline-button
            [class.saveButton]="highlightAddButton"
            [class.actionBlocked]="isAddBlocked"
            (click)="onSubmit()"
            >{{ 'add' | translate }}</button>
        }
        @if (isMyLoads) {
          <button outline-button (click)="onSubmit()">{{ 'save' | translate }}</button>
        }
      </div>
    }

    @if (project.workSpaces.length > 1) {
      <div
        class="submitWrapper"
        [glPremium]="chosenLoad?.isUser"
        [glTooltip]="individualAddBlocked ? 'individual_add_blocked_stacking_mode' : null"
        [disableTooltip]="!individualAddBlocked"
        >
        @if (!isMyLoads) {
          <button
            class="submitButton"
            outline-button
            [class.saveButton]="highlightAddButton"
            [class.actionBlocked]="isAddBlocked"
            (click)="onSubmit()"
            >
            {{ 'add' | translate }}
          </button>
        }
        @if (isMyLoads) {
          <button class="submitButton" outline-button (click)="onSubmit()">
            {{ 'save' | translate }}
          </button>
        }
      </div>
    }

    <button (click)="onReset()" outline-icon-button>
      <gl-icon name="delete"></gl-icon>
    </button>
    @if (chosenLoad && !isMyLoads) {
      <button (click)="onInitialDimensions()" outline-icon-button>
        <gl-icon name="startArrangement"></gl-icon>
      </button>
    }
  </div>
</form>

@if (isColorPicker) {
  <gl-color-picker
    (closeColorPicker)="closeColorPicker()"
    (glMousedownOutside)="closeColorPicker()"
    (choosenColor)="setColor($event)"
  ></gl-color-picker>
}
